import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { WebhookDTO, WebhookEventType } from '../../core/models';

@Component({
  selector: 'app-webhook-read',
  templateUrl: './webhook-read.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TagModule]
})
export class WebhookReadComponent {
  webhook = input.required<WebhookDTO>();

  private readonly eventLabels: Record<WebhookEventType, string> = {
    CUSTOMER_CREATED: 'customer.created',
    CUSTOMER_UPDATED: 'customer.updated',
    CUSTOMER_DELETED: 'customer.deleted',
    PRODUCT_CREATED: 'product.created',
    PRODUCT_UPDATED: 'product.updated',
    PRODUCT_DELETED: 'product.deleted',
    SALE_CREATED: 'sale.created',
    SALE_UPDATED: 'sale.updated',
    SALE_DELETED: 'sale.deleted',
    PAYMENT_CREATED: 'payment.created',
    SUBSCRIPTION_CREATED: 'subscription.created',
    SUBSCRIPTION_UPDATED: 'subscription.updated',
    SUBSCRIPTION_DELETED: 'subscription.deleted',
    INVOICE_CREATED: 'invoice.created',
    INVOICE_UPDATED: 'invoice.updated',
    CHARGE_OVERDUE: 'charge.overdue',
    CHARGE_DELINQUENT: 'charge.delinquent',
    RECONCILIATION_CREATED: 'reconciliation.created',
    MIT_MANDATE_CREATED: 'mit_mandate.created',
    MIT_MANDATE_UPDATED: 'mit_mandate.updated',
    MIT_MANDATE_CARD_EXPIRING: 'mit_mandate.card_expiring',
    MIT_TRANSACTION_CREATED: 'mit_transaction.created',
    MIT_TRANSACTION_UPDATED: 'mit_transaction.updated'
  };

  headerEntries(): { key: string; value: string }[] {
    const headers = this.webhook().headers;
    if (!headers) return [];
    return Object.entries(headers).map(([key, value]) => ({ key, value }));
  }

  eventLabel(event: WebhookEventType | string): string {
    return this.eventLabels[event as WebhookEventType] ?? event;
  }
}
